// Current level of a section. The gauge Cloud Function writes it to sectionsLevels/{sectionId}, which only members
// can read (everyone for free_access sections, see firestore.rules). The same fields used to be on the public
// section doc: they are ignored there, so the site never shows a level the rules wouldn't allow.
export const LEVEL_FIELDS = ["current_level", "current_trend", "level_last_update", "level_status", "level_sparkline"];

// The section without its legacy level fields, with the fields of its sectionsLevels doc (when readable).
// The id is copied explicitly: the bound section docs expose it as a non-enumerable property.
export function withSectionLevels(section, levels) {
  if (!section) return section;
  const merged = { ...section };
  LEVEL_FIELDS.forEach((field) => delete merged[field]);
  if (levels) {
    LEVEL_FIELDS.forEach((field) => {
      if (levels[field] !== undefined) merged[field] = levels[field];
    });
  }
  if (section.id !== undefined) merged.id = section.id;
  return merged;
}

// Same rule as firestore.rules: the level is readable by members, and by everyone on free_access sections
export function canReadSectionLevels(section, isMember) {
  return Boolean(isMember) || section?.free_access === true;
}
